import React from 'react';

export type LinkWrapperProps = {
  href: string;
  children: React.ReactNode;
};

export type LinkWrapper = (props: LinkWrapperProps) => JSX.Element;

const DefaultLinkWrapper: LinkWrapper = ({ href, children }) => (
  <a href={href}>{children}</a>
);

export default DefaultLinkWrapper;
